module.exports = __webpack_public_path__ + "img/bg.0f75a057.png";